<div class="container" play-audio onShowSound="error">
    <div class="row" >
        <div class="col-12 col-offset-0">
            <h3 [innerHTML]="'404.headers.top' | translate"></h3>
            <p [innerHTML]="'404.text.page_not_available' | translate"></p>

            <button
                [routerLink]="'/game/dashboard'"
                class="btn-default"
                play-audio
                onClickSound="btn_default_click"
                onEnterSound="btn_default_enter"
            >
                <span [innerHTML]="'404.text.go_to_dashboard_to_see_page' | translate"></span>
            </button>
        </div>
    </div>
</div>